var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('resource-menu'),_c('common-view'),_c('common-footer'),_c('kdw-Cookiebar-card',{model:{value:(_vm.cookieUpdate),callback:function ($$v) {_vm.cookieUpdate=$$v},expression:"cookieUpdate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }